import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import type { ValidatorComponentProps } from 'react-material-ui-form-validator';
import { TextValidator } from 'react-material-ui-form-validator';

import { inputBoxStyles } from './inbox-styles';

export const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'margin',
})(({ theme, margin }) => ({
  ...inputBoxStyles({ theme, margin }),
}));

export const StyledTextValidator = styled(TextValidator)(({ theme, margin }) => ({
  ...inputBoxStyles({ theme, margin }),
}));

export type TStyledTextValidator = ValidatorComponentProps;
